import { ahoraDeLaApp } from './horaEspana';
/**
 * EL AÑO DE UN HITO DE PESO («tu máximo peso», «tu mejor forma»), COMPROBADO (ALT-12, 14-10).
 *
 * La pantalla ya avisaba de un año raro, pero en la pregunta opcional el aviso no apagaba
 * el botón: «75 kg (2030)» se guardaba en la ficha que lee el entrenador. Y el aviso decía
 * «con sus cuatro cifras» a un año que las tiene. Aquí, la regla y su frase: cuatro cifras,
 * no antes de 1940 ni de su nacimiento, y no un año que todavía no ha llegado.
 *
 * La misma regla está en el servidor (`por_que_no_vale_el_ano` en `backend/core/alta.py`).
 */
export const PRIMER_ANO = 1940;

/** La frase que explica por qué ese año no vale, o `null` si vale (o si está en blanco). */
export const porQueNoValeElAno = (valor, nacimiento = null, hoy = ahoraDeLaApp()) => {
    const crudo = `${valor ?? ''}`.trim();
    if (crudo === '') return null;
    const ano = /^\d{4}$/.test(crudo) ? parseInt(crudo, 10) : NaN;
    if (isNaN(ano) || ano < PRIMER_ANO) return 'El año, con sus cuatro cifras.';
    if (ano > hoy.getFullYear()) return 'Ese año todavía no ha llegado.';
    const nacio = parseInt(String(nacimiento ?? '').slice(0, 4), 10);
    if (!isNaN(nacio) && ano < nacio) return 'Ese año es anterior a tu nacimiento.';
    return null;
};
